module.exports = __webpack_public_path__ + "img/ico.7d91e58c.png";